import React, { useState } from "react";
import {
    Fab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography,
    IconButton,
    Box,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import axios from "axios";
import AiSuggestionsItemCard from "../sections/aiSuggestionsItemCard";
import {
    getAuth,
    setMobileBackColor,
    setMobileTextColor,
    setMobileTextField_BK_FONT_Border_StyleColor,
} from "../../../utility";
import SuggestionMainItemInfo from "../Item/suggestionMainItemInfo";
import helpMessageIconDark from "../../../images/Featured icon.png";
import helpMessageIconLight from "../../../images/Featured icon-1.png";
import { t } from "i18next";
import { Description } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";

const FloatingChatButton = ({
    qrCode,
    qrName,
    sympole,
    handleFavorite,
    favorites,
    suggested,
    onActionDone,
    treeData
}) => {
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState([]); // State for API response items
    const [loading, setLoading] = useState(false); // Loading state for API request
    const [userQuery, setUserQuery] = useState(""); // State for the user's typed input
    const [resDescription, setResDescription] = useState(""); // State for the user's typed input
    const [selectedItem, setSelectedItem] = useState(null); // State for the selected item
    const [openItemDialog, setOpenItemDialog] = useState(false); // State to control the item details dialog
    const [openNoDataDialog, setOpenNoDataDialog] = useState(false);
    const theme = localStorage.getItem("theme");
    const lang = localStorage.getItem("lang");
    const [params, setParams] = useSearchParams();


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setItems([]);
        setUserQuery("");
        setResDescription("");
    };

    const handleSend = async () => {
        setItems([]);
        setResDescription("");
        setUserQuery("");
        setLoading(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API}/menus/${qrCode}/recommend-items-with-ai-2`,
                {
                    prompt: userQuery,
                },
                getAuth()
            );
            const fetchedItems = response?.data?.data?.items;
            const Description = response?.data?.data?.description;
            setResDescription(Description)

            if (!fetchedItems || fetchedItems.length === 0) {
                // setOpenNoDataDialog(true);
            } else {
                setItems(fetchedItems);

            }
        } catch (error) {
            console.error("Error fetching items:", error);
        } finally {
            setLoading(false);
        }
    };



    const handleOpenItemDialog = (item) => {
        setSelectedItem(item);
        setOpenItemDialog(true);
    };

    const handleCloseItemDialog = () => {
        setOpenItemDialog(false);
        setSelectedItem(null);
    };

    const handleCloseNoDataDialog = () => {
        setOpenNoDataDialog(false);
    };

    return (
        <>
            <Fab
                color="primary"
                aria-label="help"
                onClick={handleClickOpen}
                style={{
                    position: 'fixed',
                    bottom: !treeData?.details?.order_ability && !treeData?.details?.whatsapp ? '10px' : '90px',
                    right: '16px',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                    backgroundColor: setMobileBackColor(),
                }}
            >
                {theme === "dark" ?
                    <img src={helpMessageIconDark} style={{ width: "60px", height: "60px" }} />
                    : <img src={helpMessageIconLight} style={{ width: "60px", height: "60px" }} />
                }
            </Fab>



            <Dialog
                open={openNoDataDialog}
                onClose={handleCloseNoDataDialog}
                maxWidth="xs"
                PaperProps={{
                    style: {
                        borderRadius: 15,
                        padding: "20px",
                        backgroundColor: setMobileBackColor()
                    },
                }}
            >
                <DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
                    <Typography variant="h5" fontWeight="bold" color={setMobileTextField_BK_FONT_Border_StyleColor()[0]}>
                        {t("No Matching Data")}
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Box sx={{ display: "flex", justifyContent: "center", padding: "20px 10px" }}>
                        <Typography variant="body1" textAlign="center" color={setMobileTextField_BK_FONT_Border_StyleColor()[1]}>
                            {t("No data matching your search.")}
                        </Typography>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                        onClick={handleCloseNoDataDialog}
                        sx={{
                            backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
                            color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
                            padding: "10px 20px",
                            borderRadius: "30px",
                            "&:hover": {
                                backgroundColor: "primary.dark",
                            },
                        }}
                    >
                        {t("Close")}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    style: {
                        overflow: "hidden",
                        borderRadius: "8px",
                        padding: "10px",
                        marginTop: "18%",
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
                        backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
                        color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
                    },
                }}
            >
                <DialogTitle >
                    {lang === "ar" || lang === "fa" ? (<div style={{ direction: 'rtl', textAlign: 'right' }}>
                        <Typography className="sub-font" variant="h5" style={{ fontWeight: 'bold', color: setMobileTextColor() }}>
                            {t("Need Help?")}
                        </Typography>
                    </div>) : (<div style={{ direction: 'ltr', textAlign: 'left' }}>
                        <Typography className="sub-font" variant="h5" style={{ fontWeight: 'bold', color: setMobileTextColor() }}>
                            {t("Need Help?")}
                        </Typography>
                    </div>)
                    }

                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    style={{
                        overflow: 'hidden',
                    }}
                >
                    {lang === "ar" || lang === "fa" ? (
                        <div style={{ direction: 'rtl', textAlign: 'right' }}>
                            <Typography className="sub-font" variant="body2" style={{ marginBottom: "10px", color: setMobileTextColor() }}>
                                {t("Please type your question below, and I will assist you shortly.")}
                            </Typography>
                        </div>
                    )
                        :
                        (
                            <div style={{ direction: 'ltr', textAlign: 'left' }}>
                                <Typography className="sub-font" variant="body2" style={{ marginBottom: "10px", color: setMobileTextColor() }}>
                                    {t("Please type your question below, and I will assist you shortly.")}
                                </Typography>
                            </div>
                        )}

                    <TextField
                        className="sub-font"
                        autoFocus
                        margin="dense"
                        id="helpQuery"
                        fullWidth
                        placeholder={t("Ask Your Question")}
                        variant="outlined"
                        multiline
                        rows={1}
                        value={userQuery}
                        onChange={(e) => setUserQuery(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSend();
                            }
                        }}
                        InputProps={{
                            style: {
                                direction: lang === "ar" || lang === "fa" ? "rtl" : "ltr",
                                textAlign: lang === "ar" || lang === "fa" ? "right" : "left",
                                borderRadius: '8px',
                                backgroundColor: setMobileBackColor(),
                                color: setMobileTextColor(),
                                borderWidth: 1,
                                borderStyle: "solid",
                                borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
                                fontFamily:
                                localStorage.getItem("lang") === "ar" ||
                                localStorage.getItem("lang") === "fa"
                                  ? "Almarai"
                                  : "Roboto", 
                            },
                        }}
                        InputLabelProps={{
                            style: {
                                color: setMobileTextColor(),
                                textAlign: lang === "ar" || lang === "fa" ? "right" : "left",
                                fontFamily:
                                localStorage.getItem("lang") === "ar" ||
                                localStorage.getItem("lang") === "fa"
                                  ? "Almarai"
                                  : "Roboto", 
                            },
                        }}

                        sx={{
                            "input::placeholder": {
                              fontFamily:
                                localStorage.getItem("lang") === "ar" ||
                                localStorage.getItem("lang") === "fa"
                                  ? "Almarai"
                                  : "Roboto", 
                            },
                            "& input": {
                              fontFamily:
                                localStorage.getItem("lang") === "ar" ||
                                localStorage.getItem("lang") === "fa"
                                  ? "Almarai"
                                  : "Roboto", 
                            },
                          }}
                    />
                    {loading && lang === "ar" || lang === "fa" ? (<div style={{ direction: 'rtl', textAlign: 'right' }}>
                        <Typography className="sub-font">{t("Loading...")}</Typography>
                    </div>) : loading && (<div style={{ direction: 'ltr', textAlign: 'left' }}>
                        <Typography className="sub-font">{t("Loading...")}</Typography>
                    </div>)}

                    {items?.length > 0 ? (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            WebkitOverflowScrolling: 'touch', // for smooth scrolling in iOS
                            paddingRight: '10px', // add some space for the scrollbar
                        }} className="sub-font">

                            {resDescription.length > 0 ?
                                <p style={{ direction: lang === "ar" || lang === "fa" ? "rtl" : "ltr", color: setMobileTextColor() ,                              fontFamily:
                                    localStorage.getItem("lang") === "ar" ||
                                    localStorage.getItem("lang") === "fa"
                                      ? "Almarai"
                                      : "Roboto"}}>
                                    {resDescription}
                                </p> : ""}

                            {items.map((item) => (
                                <AiSuggestionsItemCard
                                    key={item.id}
                                    item={item}
                                    in_root={false}
                                    qrCode={qrCode}
                                    qrName={qrName}
                                    sympole={sympole || ""}
                                    handleFavorite={handleFavorite}
                                    favorites={favorites}
                                    suggested={suggested}
                                    handleOpenItemDialog={(item) => handleOpenItemDialog(item)} // Open item dialog on click
                                />
                            ))}

                        </div>
                    ) : (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '300px',
                            overflowY: 'auto',
                            WebkitOverflowScrolling: 'touch', // for smooth scrolling in iOS
                            paddingRight: '10px', // add some space for the scrollbar
                        }} className="sub-font">

                            {resDescription.length > 0 ?
                                <p style={{ direction: lang === "ar" || lang === "fa" ? "rtl" : "ltr", color: setMobileTextColor() }}>
                                    {resDescription}
                                </p> : ""}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button className="sub-font" onClick={handleClose} color="secondary" variant="outlined" style={{ borderRadius: '8px', backgroundColor: setMobileBackColor(), color: setMobileTextColor() }}>
                        {t("Cancel")}
                    </Button>
                    <Button className="sub-font" onClick={handleSend} color="primary" variant="contained" style={{ borderRadius: '8px' }}>
                        {t("Search")}
                    </Button>
                </DialogActions>
            </Dialog>

            {selectedItem && (
                <Dialog
                    open={openItemDialog}
                    onClose={handleCloseItemDialog}
                    fullWidth
                    fullScreen
                    maxWidth="sm"
                    PaperProps={{
                        style: {
                            height: "100%",
                            backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
                            color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
                        },
                    }}
                >
                    <SuggestionMainItemInfo
                        item={selectedItem}
                        sympoleData={sympole}
                        handleFavorite={handleFavorite}
                        favorites={favorites}
                        tableQr={qrCode}
                        tableName={qrName}
                        handleCloseItemDialog={handleCloseItemDialog}
                        onActionDone={onActionDone}
                        treeData={treeData}
                    />
                </Dialog>
            )}
        </>
    );
};

export default FloatingChatButton;
